export default __webpack_public_path__ + "images/c6c31d3d049ff9f86a3db1cd19d28525.png";